import React, { useState, useEffect } from "react";
import { Button, Modal } from "semantic-ui-react";

const CountrySpecificKPModal = (props) => {
  let { open, onClose, desc } = props;
  const [stateOpen, setStateOpen] = useState(open);

  useEffect(() => {
    setStateOpen(props.open);
  }, [props.open]);

  return (
    <Modal className="auto-modal" open={stateOpen}>
      <div className="import-modal">
        <div className="import-modal__ttl">Notification</div>
        <div className="import-modal__desc" dangerouslySetInnerHTML={{ __html: desc }}></div>
        <div className="import-modal__footer">
          <Button
            className="btn_bck_color"
            onClick={() => {
              onClose();
              setStateOpen(false);
            }}
            title="ok"
          >
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CountrySpecificKPModal;
